import * as React from 'react';
import { ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import { MDXProvider } from '@mdx-js/react';
import { sereneShellTheme } from './src/styles/serene-shell.theme';
import { YouTube } from './src/components/mdx/YouTube';
import { ResponsiveVideo } from './src/components/mdx/ResponsiveVideo';
import './src/styles/serene-shell.css';

const mdxComponents = { YouTube, ResponsiveVideo };

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <StyleProvider hashPriority="high">
    <ConfigProvider theme={sereneShellTheme}>
      <MDXProvider components={mdxComponents}>{element}</MDXProvider>
    </ConfigProvider>
  </StyleProvider>
);
